import { useState, useEffect } from "react";
import Swal from "sweetalert2";

const UserModal = ({ show, onClose, onSubmit }) => {
    const [email, setEmail] = useState("");
    const [role, setRole] = useState("");

    useEffect(() => {
        if (show) {
            setEmail("");
            setRole("");
        }
    }, [show]);

    if (!show) return null;

    const handleSubmit = () => {
        if (!email || !role) {
            Swal.fire("Required", "Email and Role are required", "warning");
            return;
        }
        onSubmit({ email, role });
    };

    return (
        <>
            {/* Backdrop */}
            <div
                className="modal-backdrop fade show"
                onClick={onClose}
            ></div>

            {/* Modal */}
            <div
                className="modal d-block"
                tabIndex="-1"
                style={{ zIndex: 1055 }}
            >
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title">Add User</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                            ></button>
                        </div>

                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Role</label>
                                <select
                                    className="form-select"
                                    value={role}
                                    onChange={(e) => setRole(e.target.value)}
                                >
                                    <option value="">-- Select Role --</option>
                                    <option value="Teacher">Teacher</option>
                                    <option value="Staff">Staff</option>
                                </select>
                            </div>

                            <div className="alert alert-info py-2">
                                Default password will be assigned automatically.
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                className="btn btn-secondary"
                                onClick={onClose}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={handleSubmit}
                            >
                                Create User
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default UserModal;
